export const ssoConfig = {
  appId: 5,
  sso: {
    tokenExpiresInMin: 2,
    timeBeforeCallingRefreshInSecs: 15
  },
};
